import { WorkflowNode } from './workflow-node.model';
import { WorkflowNodeType } from './workflow-node-type.enum';
import { WorkflowNodeRuleType } from './workflow-node-rule-type.enum';
import { WorkflowNodeActionType } from './workflow-node-action-type.enum';

const RULE_ICONS: Record<WorkflowNodeRuleType, string> = {
  [WorkflowNodeRuleType.Condition]: 'call_split',
  [WorkflowNodeRuleType.WaitForTrigger]: 'hourglass_empty',
  [WorkflowNodeRuleType.TimeDelay]: 'schedule'
};

const ACTION_ICONS: Record<WorkflowNodeActionType, string> = {
  [WorkflowNodeActionType.SendEmail]: 'mail',
  [WorkflowNodeActionType.Webhook]: 'webhook'
};

const TYPE_ICONS: Record<WorkflowNodeType, string> = {
  [WorkflowNodeType.Trigger]: 'bolt',
  [WorkflowNodeType.Terminator]: 'stop_circle',
  [WorkflowNodeType.Rule]: 'rule',
  [WorkflowNodeType.Action]: 'play_arrow'
};

/**
 * The Material Symbol a node is drawn with, matched to the palette button it
 * was added from. Keyed on the sub-type where there is one, so a Time Delay
 * reads as a clock rather than as any other rule. The bare-type icons are
 * fallbacks for a node whose sub-type is unset.
 */
export function nodeTypeIconFor(
  node: Pick<WorkflowNode, 'type' | 'ruleType' | 'actionType'>
): string {
  if (node.type === WorkflowNodeType.Rule && node.ruleType) return RULE_ICONS[node.ruleType];
  if (node.type === WorkflowNodeType.Action && node.actionType) return ACTION_ICONS[node.actionType];
  return TYPE_ICONS[node.type];
}
